import { render } from "./FooterAddress.vue?vue&type=template&id=051a96e6&scoped=true"
import script from "./FooterAddress.vue?vue&type=script&lang=js"
export * from "./FooterAddress.vue?vue&type=script&lang=js"

import "./FooterAddress.vue?vue&type=style&index=0&id=051a96e6&scoped=true&lang=css"

import exportComponent from "/Users/yourkesa/Downloads/qron_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051a96e6"]])

export default __exports__